import { useEnvironment, useGlobal } from "../../../core/Global";
import FlexRow from "../../base/FlexRow";
import Icon from "../../base/Icon";



export default function MobileHeader() {

    const env = useEnvironment()
    const [globalState] = useGlobal()

    const titleTap = globalState.pageTitleTap



    return (
        <FlexRow className="d-lg-none px-5 w-100">

            <FlexRow>

                {
                    globalState.page ?
                        (
                            titleTap ?
                                <div className="d-flex align-items-center cursor-pointer"
                                    style={{ fontSize: 26, fontWeight: "bolder" }}
                                    onClick={() => titleTap()}>
                                    {globalState.page.title}
                                    <Icon icon="chevron-down" size={15} className="ms-2 text-gray-500" />
                                </div>
                                :
                                <div style={{
                                    fontSize: 26,
                                    fontWeight: "bolder"
                                }}>
                                    {globalState.page.title}
                                </div>
                        )
                        :
                        <>
                            <img src={`/assets/brands/${env.brand}/icon.png`} className="h-25px" />
                            <div className="ms-1 fw-bolder" style={{
                                color: "#333",
                                fontSize: 16,
                                fontFamily: "Poppins"
                            }}>
                                {env.siteTitle}
                            </div>
                        </>
                }

            </FlexRow>

            <FlexRow className="ms-auto">

                {
                    globalState.mobileToolbar && <globalState.mobileToolbar />
                }

            </FlexRow>

        </FlexRow>
    )
}